import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GraphQLService } from './graph-ql.service';
import { ProductsResult, ProductThumb } from '../models';
import { productCard, productListCard } from './product-queries';
import { filterByExactSku } from 'src/app/utility/find-by-exact-sku.utility';
@Injectable({
  providedIn: 'root',
})
export class SearchService extends GraphQLService {
  constructor() {
    super();
  }

  getGlobalSearchResults(searchQuery: string, language?: string) {
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.addConnection('search', { args: { first: 20, query: searchQuery, types: this.client.enum('PRODUCT') } }, (q: any) => {
        q.addInlineFragmentOn('Product', (products: any) => {
          productListCard(products, this.client);
        });
      });
    });

    return from(this.client.send(query)).pipe(map((res: any) => filterByExactSku(res?.data?.search, searchQuery))) as Observable<
      ProductThumb[]
    >;
  }

  getSearchResults(searchQuery: string, after: string = '', language?: string) {
    const args: any = { first: 24, query: searchQuery, types: this.client.enum('PRODUCT') };
    if (after) {
      args['after'] = after;
    }
    const query = this.client.query(`@inContext(language: ${language})`, (root: any) => {
      root.addConnection('search', { args: { ...args } }, (q: any) => {
        q.addInlineFragmentOn('Product', (products: any) => {
          productCard(products, this.client);
        });
      });
    });

    return from(this.client.send(query)).pipe(
      map((res: any) => filterByExactSku(res?.data?.search, searchQuery))
    ) as Observable<ProductsResult>;
  }
}
